<template>
    <div id="recruiter_index_evaluations" class="flex_content">

        <div id="context_bar">
            <TopbarSearchEval />
        </div>

        <titlePage>
            <template slot="titleBody">
                <h1 class="page-title title is-size-1">
                    {{ $t('modules.evaluations.index.title') }}
                </h1>
                <div class="has-text-centered">
                    <router-link to="/evaluations/new" >
                        <button class="button  is-info is-rounded is-outlined">
                            {{ $t('modules.evaluations.index.newEval') }}
                        </button>
                    </router-link>
                </div>
            </template>
        </titlePage>

        <div id="index_eval_content" class="hero flex">
            <div class="hero-body flex_content">
                <div class="container has-text-centered ">

                     <!-- <CardsListEvals></CardsListEvals>  -->

                    <tableEvals></tableEvals>

                    <div class="bulk_actions_container">
                        <div class=" flex_content">
                            <div class="container flex">
                                <div class="bulk_actions_dropdown">
                                    <BulkActionsDropdown :positionsList="positionsList" />
                                    <span class="selected_evals_number">{{ SelectedEvalsNumber }} {{ $t('modules.evaluations.index.selectedEvalsNumber') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <nav class="pagination table-pagination is-centered is-medium">
                        <paginate
                            :page-count="totaPages"
                            :click-handler="OnPageChange"
                            :prev-text="'<'"
                            :next-text="'>'"
                            :page-link-class="'pagination-link'"
                            :active-class="'is-current'"
                            :prev-link-class="'pagination-link'"
                            :next-link-class="'pagination-link'"
                            :disabled-class="'is-disabled'"
                            :container-class="'pagination-list'">
                        </paginate>
                    </nav>

                </div>
            </div>
        </div>

    </div>

</template>

<script>
import TitlePage from "@/components/layouts/titlePage"
import TopbarSearchEval from "../components/topbar/topbarSearchEval"
import TableEvals from "../components/index/tableEvals"
import CardsListEvals from "../components/index/cardsListEvals"
import BulkActionsDropdown from "../components/index/bulkActionsDropdown"


export default {
    name: 'EvaluationsIndex',
    components: {
        TitlePage,
        CardsListEvals,
        TopbarSearchEval,
        TableEvals,
        BulkActionsDropdown
    },
    beforeCreate() {
        this.$store.dispatch('EvalStore/indexEvals', {page: 1})
        this.$store.dispatch('EvalStore/resetSelectedEvals')
    },
    data(){
        return {}
    },
    computed: {
        totaPages(){
            return this.$store.state.EvalStore.totalPages
        },
        SelectedEvalsNumber(){
            return this.$store.state.EvalStore.selectedEvals.length
        },
        positionsList(){
            return this.$store.state.PositionStore.positionsList
        },
    },
    methods: {
        OnPageChange(currentpage){
            this.$store.dispatch('EvalStore/indexEvals', {page: currentpage})
        }
    }
}
</script>

<style lang="scss">
#index_eval_content{
    background: $white;
}
.bulk_actions_container{
    background: white;
    .bulk_actions_dropdown{
        display: flex;
        align-items: center;
        .selected_evals_number{
            padding-left: 12px;
            font-weight: 500;
        }
    }
}
.pagination{
    padding: 30px 0;
    li.is-current a{
        background-color: $info;
        border-color: $info;
        color: #fff;
    }
    li.is-disabled a{
        background-color: #dbdbdb;
        border-color: #dbdbdb;
        -webkit-box-shadow: none;
        box-shadow: none;
        color: #7a7a7a;
        opacity: 0.5;
        cursor: default;
    }
}

</style>